const staff = require('./staff/staff')
const warehouseApp = require('./warehouse/warehouse-app')
const client = require('./client/client')


export function start(settingsData) {
	// console.log('applications>', settingsData)

	if (settingsData.typeApp === "staff") {
		if (settingsData.device.deviceType === 'desktop' || settingsData.device.deviceType === 'tv') {
			staff.start(settingsData);
			return
		}

		if (settingsData.device.deviceType === "smartphone") {
			settingsData.typeApp = 'warehouse';
			warehouseApp.start(settingsData)
			return
		}
	}

	if (settingsData.typeApp === "client") {
		client.start(settingsData);
		return
	}

}